<style lang="less">
  @import "./Share.less";
</style>

<template>
  <div class="share" v-if="isNavigate">
    <van-cell-group>
      <van-cell title="IMEI" icon="setting-o" :value="nowImei" />
    </van-cell-group>
    <img src="../../../assets/images/img_share_arrow.png" alt="">
    <img src="../../../assets/images/img_share_tip.png" alt="">
  </div>
</template>

<script>
import Share from './Share.js'
export default {
  ...Share
}
</script>
